export const serverErrors = Object.freeze({
  accessDeniedError: {
    code: 'ACCESS_DENIED_ERROR',
    message: ''
  },
  badCredentialError: {
    code: 'BAD_CREDENTIAL_ERROR',
    message: ''
  },
  badInputError: {
    code: 'BAD_INPUT_ERROR',
    message: ''
  },
  invalidChangePasswordCodeError: {
    code: 'INVALID_CHANGE_PASSWORD_CODE_ERROR',
    message: ''
  },
  invalidMfaCodeError: {
    code: 'INVALID_MFA_CODE_ERROR',
    message: ''
  },
  notFoundError: {
    code: 'NOT_FOUND_ERROR',
    message: ''
  },
  unauthorizedError: {
    code: 'UNAUTHORIZED_ERROR',
    message: ''
  },
  unexpectedError: {
    code: 'UNEXPECTED_ERROR',
    message: ''
  }
})
